import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useDebouncedCallback } from "use-debounce";
import { RootContext } from "../../App";
import TableAdjustmentRequset from "../../components/TableAdjustmentRequest";
import axiosInstance from "../../config/axios";
import refactorStructureData from "../../helpers/refactorDataMenu";


export default function WithdrawRequest() {
  const [data, setData] = useState();
  const [pending, setPending] = useState(true);
  const [length, setLength] = useState(10)
  const [username, setUsername] = useState()
  const [date, setDate] = useState()
  const history = useHistory()
  const [accept, setAccept] = useState(1)
  const [decline, setDecline] = useState(1)
  const { state, setState } = useContext(RootContext)
  const debounced = useDebouncedCallback((action) => {
    action()
  }, 200)

  useEffect(() => {
    getData()
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [length, username, date, accept, decline])


  const getData = () => {

    const token = localStorage.getItem("access_token");

    const group = JSON.parse(localStorage.getItem("group"))
    const data = {
      token: token,
      group: group.wbid,
      lgth: length,
      user: username,
      date: date
    }
    if (!token) {
      history.push("/login");
    } else {
      try {

        axiosInstance("get_adjustment_request", {
          method: "POST",
          data,
        })
          .then((res) => {
            const data = res.data.data.list
            setState({
              ...state,
              group: res.data.data.additional_data.group,
              menu: refactorStructureData(res.data.data.additional_data.menu),
            });
            setData(data)
          })
          .then(() => {
            setPending(false);
          })
          .catch((err) => {
            localStorage.removeItem("access_token");
            history.push("/login");
          });
      } catch (error) {
        console.log("ERROR: ", error);
      }
    }
  };


  return (
    <>
      <div className="bg-light-blue-500 pt-7 pb-28 px-3 md:px-8 h-auto"></div>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <TableAdjustmentRequset
              data={data}
              pending={pending}
              usernameEvent={(event) => {
                debounced(setUsername(event.target.value))
              }}
              dateEvent={(event) => {
                setDate(event.target.value)
              }}
              onChangeRowsPerPage={(row) => {
                setLength(row)
              }}
              acceptEvent={(event) => {
                setTimeout(() => setAccept(accept + 1), 1000)
              }}
              declineEvent={(event) => {
                setTimeout(() => setDecline(decline + 1), 1000)
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
